import React, { Component } from "react";
import Activities from "views/profile/components/my-activities/Activities";
import BookMark from "views/profile/components/bookmark/BookMark.js";
import Declaration from "views/profile/components/declaration/Declaration.js";
import EKYC from "views/profile/components/ekyc/EKYC.js";
import Documents from "views/profile/components/documents/Documents.js";
import Profiler from "views/profile/components/profiler/Profiler.js";
// import { User, Activity, Bookmark, Award, FileText } from "react-feather";
import ProfileTab from "views/profile/profile/ProfileTab";
import usericon from "views/profile/img/tabs/user.svg";
import jobs from "views/profile/img/tabs/jobs.svg";
import activityicon from "views/profile/img/tabs/activity.svg";
import bookmarkicon from "views/profile/img/tabs/bookmark.svg";
import declarationicon from "views/profile/img/tabs/declaration.svg";
import profilericon from "views/profile/img/tabs/profiler.svg";
import documentsicon from "views/profile/img/tabs/documents.svg";
import ekyc from "views/profile/img/tabs/ekyc.svg";
import MyJobs from "views/profile/components/my-jobs/MyJobs";
import MyOffers from "views/profile/components/my-offers/MyOffers";
class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTabOpenNo: 1,
    };
  }
  render() {
    return (
      <div class="mt-8 pb-12">
        <ul class="list-reset flex overflow-x-auto lg:absolute md:absolute lg:w-10/12 md:w-10/12 lg:top-0 md:top-0 lg:right-0 md:right-0 justify-between lg:flex-wrap md:flex-wrap bgF7F7F7 rounded-28px sm-rounded-none py-4 lg:px-16 md:px-16 px-4">
          <li
            className={
              this.state.isTabOpenNo == 1
                ? "font-bold text-black  active tab-activc-p text-center cursor-pointer  sm-px10 "
                : "-mb-px  lg:mr-1 md:mr-1 text-center cursor-pointer sm-px10"
            }
            onClick={() => this.setState({ isTabOpenNo: 1 })}
          >
            <div
              className={
                this.state.isTabOpenNo == 1
                  ? "flex justify-center bgE77820 items-center  rounded-full profile-tabs-w m-auto"
                  : "flex justify-center bg-white rounded-full items-center profile-tabs-w m-auto"
              }
            >
              <img
                src={usericon}
                alt="icon"
                className={
                  this.state.isTabOpenNo == 1
                    ? "filter-white  profile-tabs-icon"
                    : "text-white  profile-tabs-icon"
                }
              />
            </div>

            <p className=" text262626  lg:pt-1 md:pt-1 pt-3 fsize14">Profile</p>
          </li>

          <li
            className={
              this.state.isTabOpenNo == 2
                ? "font-bold text-black  active tab-activc-p text-center cursor-pointer  sm-px10"
                : "-mb-px  lg:mr-1 md:mr-1 text-center cursor-pointer sm-px10"
            }
            onClick={() => this.setState({ isTabOpenNo: 2 })}
          >
            <div
              className={
                this.state.isTabOpenNo == 2
                  ? "flex justify-center bgE77820 items-center  rounded-full profile-tabs-w m-auto"
                  : "flex justify-center bg-white rounded-full items-center profile-tabs-w m-auto"
              }
            >
              <img
                src={activityicon}
                alt="icon"
                className={
                  this.state.isTabOpenNo == 2
                    ? "filter-white profile-tabs-icon"
                    : "text-white  profile-tabs-icon"
                }
              />
            </div>

            <p className=" text262626  lg:pt-1 md:pt-1 pt-3 fsize14">
              My Activities
            </p>
          </li>

          <li
            className={
              this.state.isTabOpenNo == 3
                ? "font-bold text-black  active tab-activc-p text-center cursor-pointer  sm-px10"
                : "-mb-px  lg:mr-1 md:mr-1 text-center cursor-pointer sm-px10"
            }
            onClick={() => this.setState({ isTabOpenNo: 3 })}
          >
            <div
              className={
                this.state.isTabOpenNo == 3
                  ? "flex justify-center bgE77820 items-center  rounded-full profile-tabs-w m-auto"
                  : "flex justify-center bg-white rounded-full items-center profile-tabs-w m-auto"
              }
            >
              <img
                src={jobs}
                alt="icon"
                className={
                  this.state.isTabOpenNo == 3
                    ? "filter-white profile-tabs-icon"
                    : "text-white  profile-tabs-icon"
                }
              />
            </div>

            <p className=" text262626  lg:pt-1 md:pt-1 pt-3 fsize14">My Jobs</p>
          </li>

          <li
            className={
              this.state.isTabOpenNo == 4
                ? "font-bold text-black  active tab-activc-p text-center cursor-pointer  sm-px10"
                : "-mb-px  lg:mr-1 md:mr-1 text-center cursor-pointer sm-px10"
            }
            onClick={() => this.setState({ isTabOpenNo: 4 })}
          >
            <div
              className={
                this.state.isTabOpenNo == 4
                  ? "flex justify-center bgE77820 items-center  rounded-full profile-tabs-w m-auto"
                  : "flex justify-center bg-white rounded-full items-center profile-tabs-w m-auto"
              }
            >
              <img
                src={jobs}
                alt="icon"
                className={
                  this.state.isTabOpenNo == 4
                    ? "filter-white profile-tabs-icon"
                    : "text-white  profile-tabs-icon"
                }
              />
            </div>

            <p className=" text262626  lg:pt-1 md:pt-1 pt-3 fsize14">
              My Offers
            </p>
          </li>

          <li
            className={
              this.state.isTabOpenNo == 5
                ? "font-bold text-black  active tab-activc-p text-center cursor-pointer  sm-px10"
                : "-mb-px  lg:mr-1 md:mr-1 text-center cursor-pointer sm-px10"
            }
            onClick={() => this.setState({ isTabOpenNo: 5 })}
          >
            <div
              className={
                this.state.isTabOpenNo == 5
                  ? "flex justify-center bgE77820 items-center  rounded-full profile-tabs-w m-auto"
                  : "flex justify-center bg-white rounded-full items-center profile-tabs-w m-auto"
              }
            >
              <img
                src={bookmarkicon}
                alt="icon"
                className={
                  this.state.isTabOpenNo == 5
                    ? "filter-white  profile-tabs-icon"
                    : "text-white  profile-tabs-icon"
                }
              />
            </div>

            <p className=" text262626  lg:pt-1 md:pt-1 pt-3 fsize14">
              Book Marks
            </p>
          </li>

          <li
            className={
              this.state.isTabOpenNo == 6
                ? "font-bold text-black  active tab-activc-p text-center cursor-pointer  sm-px10"
                : "-mb-px  lg:mr-1 md:mr-1 text-center cursor-pointer sm-px10"
            }
            onClick={() => this.setState({ isTabOpenNo: 6 })}
          >
            <div
              className={
                this.state.isTabOpenNo == 6
                  ? "flex justify-center bgE77820 items-center  rounded-full profile-tabs-w m-auto"
                  : "flex justify-center bg-white rounded-full items-center profile-tabs-w m-auto"
              }
            >
              <img
                src={declarationicon}
                alt="icon"
                className={
                  this.state.isTabOpenNo == 6
                    ? "filter-white  profile-tabs-icon"
                    : "text-white  profile-tabs-icon"
                }
              />
            </div>

            <p className=" text262626  lg:pt-1 md:pt-1 pt-3 fsize14">
              Declaration
            </p>
          </li>

          <li
            className={
              this.state.isTabOpenNo == 7
                ? "font-bold text-black  active tab-activc-p text-center cursor-pointer  sm-px10"
                : "-mb-px  lg:mr-1 md:mr-1 text-center cursor-pointer sm-px10"
            }
            onClick={() => this.setState({ isTabOpenNo: 7 })}
          >
            <div
              className={
                this.state.isTabOpenNo == 7
                  ? "flex justify-center bgE77820 items-center  rounded-full profile-tabs-w m-auto"
                  : "flex justify-center bg-white rounded-full items-center profile-tabs-w m-auto"
              }
            >
              <img
                src={profilericon}
                alt="icon"
                className={
                  this.state.isTabOpenNo == 7
                    ? "filter-white  profile-tabs-icon"
                    : "text-white  profile-tabs-icon"
                }
              />
            </div>

            <p className=" text262626  lg:pt-1 md:pt-1 pt-3 fsize14">
              Profiler
            </p>
          </li>

          <li
            className={
              this.state.isTabOpenNo == 8
                ? "font-bold text-black  active tab-activc-p text-center cursor-pointer  sm-px10"
                : "-mb-px  lg:mr-1 md:mr-1 text-center cursor-pointer sm-px10"
            }
            onClick={() => this.setState({ isTabOpenNo: 8 })}
          >
            <div
              className={
                this.state.isTabOpenNo == 8
                  ? "flex justify-center bgE77820 items-center  rounded-full profile-tabs-w m-auto"
                  : "flex justify-center bg-white rounded-full items-center profile-tabs-w m-auto"
              }
            >
              <img
                src={documentsicon}
                alt="icon"
                className={
                  this.state.isTabOpenNo == 8
                    ? "filter-white  profile-tabs-icon"
                    : "text-white  profile-tabs-icon"
                }
              />
            </div>

            <p className=" text262626  lg:pt-1 md:pt-1 pt-3 fsize14">
              Documents
            </p>
          </li>

          <li
            className={
              this.state.isTabOpenNo == 9
                ? "font-bold text-black  active tab-activc-p text-center cursor-pointer  sm-px10"
                : "-mb-px  lg:mr-1 md:mr-1 text-center cursor-pointer sm-px10"
            }
            onClick={() => this.setState({ isTabOpenNo: 9 })}
          >
            <div
              className={
                this.state.isTabOpenNo == 9
                  ? "flex justify-center bgE77820 items-center  rounded-full profile-tabs-w m-auto"
                  : "flex justify-center bg-white rounded-full items-center profile-tabs-w m-auto"
              }
            >
              <img
                src={ekyc}
                alt="icon"
                className={
                  this.state.isTabOpenNo == 9
                    ? "filter-white  profile-tabs-icon"
                    : "text-white  profile-tabs-icon"
                }
              />
            </div>

            <p className=" text262626  lg:pt-1 md:pt-1 pt-3 fsize14">e-KYC</p>
          </li>
        </ul>

        <div className={this.state.isTabOpenNo == 1 ? " active" : "hidden"}>
          <div className="px-4  flex-auto">
            <div className="flex justify-center">
              <div className="relative lg:pt-1 md:pt-1 pt-4 lg:w-1/2 md:w-1/2 w-full">
                <p className="fsize14 font-semibold mb-3 lg:text-center md:text-center text-start  sm-fsize16">
                  Step 1/6{" "}
                  <span className="font-normal ml-3 text-black">
                    To complete your profile
                  </span>
                </p>
                <div className="overflow-hidden h-1 mb-4 text-xs flex rounded bgFAE5D3-transparent">
                  <div
                    style={{ width: "10%", background: "#E87F22" }}
                    className="shadow-none flex flex-col text-center whitespace-nowrap  text-white justify-center bg-amber-500"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <ProfileTab />
        </div>
        <div className={this.state.isTabOpenNo == 2 ? " active" : "hidden"}>
        {this.state.isTabOpenNo ==2 ?
          <Activities />
        :""}
        </div>

        <div className={this.state.isTabOpenNo == 3 ? " active" : "hidden"}>
          {this.state.isTabOpenNo == 3?
          <MyJobs />
          :""}
        </div>

        <div className={this.state.isTabOpenNo == 4 ? " active" : "hidden"}>
        {this.state.isTabOpenNo == 4?
          <MyOffers />
        :""}
        </div>

        <div className={this.state.isTabOpenNo == 5 ? " active" : "hidden"}>
        {this.state.isTabOpenNo == 5?
          <BookMark />
          :""}
        </div>

        <div className={this.state.isTabOpenNo == 6 ? " active" : "hidden"}>
        {this.state.isTabOpenNo == 6?
          <Declaration />
          :""}
        </div>

        <div className={this.state.isTabOpenNo == 7 ? " active" : "hidden"}>
        {this.state.isTabOpenNo == 7?
          <Profiler />
          :""}
        </div>

        <div className={this.state.isTabOpenNo == 8 ? " active" : "hidden"}>
        {this.state.isTabOpenNo == 8?
          <Documents />
          :""}
        </div>
        <div className={this.state.isTabOpenNo == 9 ? " active" : "hidden"}>
        {this.state.isTabOpenNo == 9?
          <EKYC />
          :""}
        </div>
      </div>
    );
  }
}
export default Tabs;
